/* eslint-disable */
import * as PropTypes from 'prop-types';
import React from 'react';
import RouteInfoContext from '../RouteInfoContext';
import { isMobile } from '../../../utils/commonUtils';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_ROUTE_PAGE } from '../../../utils/RailsSEOConstants';
const { Consumer: RouteInfoConsumer } = RouteInfoContext;

export default function StationTrainsSection({ trainListType }) {
  return (
    <RouteInfoConsumer>
      {({ trainsFromSource, trainsThroughSource, onTrainExtraSectionClicked, tokens }) => {
        const { source, sourceCityEn } = tokens;
        if (trainListType !== 'originating' && trainListType !== 'passing') {
          throw new Error(`Invalid trainListType: ${trainListType}`);
        }
        let showOriginatingTrains = trainListType === 'originating';
        let title;
        if (showOriginatingTrains) {
          title = trainsFromSource.title;
        } else {
          title = trainsThroughSource.title;
        }
        const trains = showOriginatingTrains ? trainsFromSource.list : trainsThroughSource.list;
        const trackEventName = showOriginatingTrains
          ? 'rail_seo_route_train_originating_clicked'
          : 'rail_seo_route_train_passingthrough_clicked';
        return trains.length > 0 ? (
          <section className="trainOriginatingList">
            <div className="heading">
              <h2>{title}</h2>
            </div>
            <ul className="makeFlex column">
              {trains.map((train) => (
                <div className="positionRelative">
                  <li
                    className="trainList loaderOnClick"
                    tabIndex={0}
                    key={train.trainNumber}
                    onClick={() => {
                      trackClickEventProp61(SEO_ROUTE_PAGE, trackEventName);
                      onTrainExtraSectionClicked({
                        fromCityEn: sourceCityEn,
                        toCityEn: train.destinationCityEn,
                        isMobile: isMobile(),
                        fromCity: source,
                        fromStn: train.sourceStn,
                        toCity: train.destinationCity,
                        toStn: train.destinationStn,
                        trainNumber: train.trainNumber
                      });
                    }}
                  >
                    <div className="left">
                      <span className="trainNo latoBold">{train.trainNumber}</span>
                      <a onClick={(e) => e.preventDefault()} href={train.trainPageUrl} className="blackText">
                        <span className="trainName latoBold">{train.trainName}</span>
                      </a>
                    </div>
                    <div className="right">
                      <span className="travelTime">{train.distance}KM&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <span className="departStation">
                        {source}({train.departureTime}){' '}
                      </span>
                      <span className="arrStation">
                        {train.destinationCity}({train.arrivalTime}){' '}
                      </span>
                    </div>
                  </li>
                </div>
              ))}
            </ul>
          </section>
        ) : null;
      }}
    </RouteInfoConsumer>
  );
}

StationTrainsSection.propTypes = {
  trainListType: PropTypes.oneOf(['originating', 'passing']),
  callbackfn: PropTypes.func
};
